var $9cc8b85ee8327c05$exports = {};
$9cc8b85ee8327c05$exports = {
    "help": `\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629}`,
    "info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`
};


export {$9cc8b85ee8327c05$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
